import axios from "axios";

import {
  LOAD_HOME_CONTENT,
  LOAD_HOME_SERVICES,
  LOAD_SERVICES_CONTENT,
  INIT_LOAD_GALLERY,
  INIT_LOAD_FEEDBACK,
  LOAD_CONTACT_CONTENT,
  LOAD_HOME_REVIEW
} from "./types";

const baseUrl = "https://api.apjhomerenovation.co.uk";
// const baseUrl = "http://localhost:8081";

export function loadHomeContent() {
  let request = axios.get(`${baseUrl}/wp-json/wp/v2/pages/13`);

  return {
    type: LOAD_HOME_CONTENT,
    payload: request
  };
}

export function loadHomeServices() {
  let request = axios.get(
    `${baseUrl}/wp-json/wp/v2/service?filter[orderby]=id&order=asc`
  );

  return {
    type: LOAD_HOME_SERVICES,
    payload: request
  };
}

export function loadHomeReview() {
  let request = axios.get(`${baseUrl}/wp-json/wp/v2/feedback?per_page=1`);

  return {
    type: LOAD_HOME_REVIEW,
    payload: request
  };
}

export function loadServicesContent() {
  let request = axios.get(
    `${baseUrl}/wp-json/wp/v2/service?filter[orderby]=id&order=asc`
  );
  return {
    type: LOAD_SERVICES_CONTENT,
    payload: request
  };
}

export function initialLoadGallery(offset) {
  let request = axios.get(
    `${baseUrl}/wp-json/wp/v2/gallery_image?per_page=10&offset=${offset}`
  );
  return {
    type: INIT_LOAD_GALLERY,
    payload: request
  };
}

export function initialLoadFeedback(offset) {
  let request = axios.get(
    `${baseUrl}/wp-json/wp/v2/feedback?per_page=5&offset=${offset}`
  );
  return {
    type: INIT_LOAD_FEEDBACK,
    payload: request
  };
}

export function loadContactContent() {
  let request = axios.get(`${baseUrl}/wp-json/wp/v2/pages/29`);
  return {
    type: LOAD_CONTACT_CONTENT,
    payload: request
  };
}



// WEBPACK FOOTER //
// ./src/actions/index.js